import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneinnovacabs() {



  const cardData = {




keyword: "Pune Innova Cabs",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune Innova Cabs for families, corporate travelers, tourists, senior citizens, and groups looking for a spacious vehicle with professional chauffeur assistance. Customers can book an Innova for Pune local travel, airport transfers, railway station pickups, corporate transportation, family functions, sightseeing, pilgrimage tours, one-way journeys, round trips, and long-distance outstation trips. With experienced drivers, clean and well-maintained vehicles, comfortable seating, generous luggage space, flexible pickup locations across Pune, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes group travel convenient and comfortable. The Innova is a practical choice for both city and highway journeys, while customers can customize the booking according to passenger count, travel duration, destination, luggage requirements, and preferred itinerary.",

topPlaces: [
  {
    title: "Bhimashankar",
    description: "Bhimashankar is a popular pilgrimage destination in the Sahyadri region and is known for its revered Jyotirlinga Temple, forest surroundings, and scenic mountain landscape. Families and groups from Pune can comfortably travel in an Innova for the winding hill-road journey. Garud Cab Service offers private chauffeur-driven cabs with flexible one-way and round-trip options."
  },
  {
    title: "Shirdi",
    description: "Shirdi is one of Maharashtra's most visited pilgrimage destinations and attracts devotees throughout the year for Sai Baba darshan. An Innova provides comfortable seating and practical luggage space for families and small groups traveling from Pune. Customers can arrange a private cab with convenient temple visit, overnight, and return travel options."
  },
  {
    title: "Nashik",
    description: "Nashik is a major religious, cultural, and commercial destination known for temples, ghats, heritage attractions, vineyards, and nearby pilgrimage sites. Families and corporate groups can use an Innova for comfortable travel from Pune. Garud Cab Service provides flexible one-way, round-trip, and customized sightseeing bookings."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is an important cultural and religious city known for Mahalaxmi Temple, historic attractions, traditional cuisine, and regional heritage. The spacious Innova is suitable for families and groups traveling from Pune with luggage. Customers can book a chauffeur-driven vehicle for pilgrimage, business travel, family visits, or sightseeing."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill station known for viewpoints, valleys, lakes, waterfalls, strawberry farms, and pleasant mountain scenery. Families and groups can enjoy a comfortable road journey from Pune in an Innova. Customers can customize the trip with multiple sightseeing stops and combine Mahabaleshwar with nearby Panchgani."
  },
  {
    title: "Goa",
    description: "Goa is a popular long-distance holiday destination known for beaches, heritage sites, churches, markets, and coastal attractions. An Innova is a suitable choice for families and groups carrying luggage on the extended Pune to Goa journey. Garud Cab Service offers private chauffeur-driven travel with flexible one-way, round-trip, and multi-day booking options."
  },
  {
    title: "Aurangabad",
    description: "Aurangabad, now officially known as Chhatrapati Sambhajinagar, is a major heritage destination with access to historic monuments, caves, and important cultural attractions. Families and groups traveling from Pune can benefit from the Innova's spacious seating and luggage capacity. Customers can plan a customized heritage and sightseeing itinerary with flexible travel schedules."
  },
  {
    title: "Solapur",
    description: "Solapur is an important city in Maharashtra known for religious sites, textile industries, business activity, and regional attractions. An Innova provides a comfortable option for families, professionals, and groups traveling from Pune. Garud Cab Service offers direct private transportation with flexible pickup and drop arrangements for one-way or return journeys."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular coastal getaway known for beaches, forts, resorts, and peaceful seaside surroundings. Families and groups from Pune can travel comfortably in an Innova while carrying luggage for a weekend or multi-day holiday. Customers can customize the route with coastal sightseeing stops and convenient return arrangements."
  },
  {
    title: "Lonavala",
    description: "Lonavala is a popular hill station close to Pune and is known for waterfalls, lakes, caves, forts, and lush green valleys. The destination is ideal for family outings and group trips requiring comfortable local transportation. Garud Cab Service provides Innova cabs with flexible hourly, one-way, round-trip, and sightseeing options around Lonavala."
  }
],




"services": [
{
"name": "Innova Taxi",
"description": "Book Innova Taxi for comfortable and spacious private transportation with professional chauffeurs and well-maintained vehicles. The service is suitable for families, groups, business travelers, airport transfers, local travel, and long-distance journeys."
},
{
"name": "Book Innova for Outstation",
"description": "Book Innova for Outstation travel when you need a spacious and comfortable vehicle for long-distance journeys. The service is suitable for families, groups, corporate passengers, sightseeing trips, religious tours, and intercity travel."
},
{
"name": "Innova Taxi Near Me Pune",
"description": "Find Innova Taxi Near Me Pune for convenient local and outstation transportation with flexible pickup arrangements. A spacious Innova can be arranged for families, groups, airport transfers, business travel, and scheduled road journeys."
},
{
"name": "Innova Cab Booking",
"description": "Make Innova Cab Booking for comfortable chauffeur-driven transportation with convenient pickup and destination drop. The service is suitable for local travel, airport transfers, family trips, corporate journeys, sightseeing, and outstation requirements."
},
{
"name": "Innova Booking Near Me Pimpri",
"description": "Choose Innova Booking Near Me Pimpri for convenient access to spacious cab transportation around Pimpri and nearby PCMC areas. The vehicle is suitable for families, groups, airport travel, business trips, and outstation journeys."
},
{
"name": "Innova Car Rental for Outstation",
"description": "Book Innova Car Rental for Outstation travel for a comfortable long-distance journey with professional driver assistance. The spacious vehicle is suitable for families, groups, corporate travelers, tourists, and passengers carrying additional luggage."
},
{
"name": "Innova for Airport Drop",
"description": "Choose Innova for Airport Drop when traveling with family, groups, or extra luggage. The spacious vehicle provides comfortable private transportation for airport transfers, with convenient pickup arrangements and direct destination drop."
},
{
"name": "Book Innova Crysta for Outstation",
"description": "Book Innova Crysta for Outstation journeys when premium comfort and spacious interiors are preferred. The vehicle is suitable for families, executives, corporate travelers, tourists, and groups planning comfortable long-distance road travel."
},
{
"name": "Innova Crysta Taxi",
"description": "Choose Innova Crysta Taxi for premium chauffeur-driven transportation with spacious seating and comfortable interiors. It is suitable for airport transfers, corporate travel, family journeys, weddings, sightseeing, and outstation trips."
},
{
"name": "Innova Cab Rental",
"description": "Book Innova Cab Rental for flexible private transportation with professional chauffeur service. The vehicle can be arranged for local travel, airport transfers, full-day requirements, family trips, corporate journeys, sightseeing, and outstation travel."
},
{
"name": "Innova Outstation Charges",
"description": "Check Innova Outstation Charges according to the travel route, vehicle requirements, journey type, and travel schedule. Innova offers practical seating and luggage space for families and groups planning one-way or round-trip transportation."
},
{
"name": "Pune Innova for Outstation",
"description": "Choose Pune Innova for Outstation travel for comfortable transportation from Pune to cities, tourist destinations, and pilgrimage locations. The spacious vehicle is suitable for families, groups, business travelers, and long-distance road trips."
},
{
"name": "Innova Taxi Booking",
"description": "Make Innova Taxi Booking for scheduled private transportation with convenient pickup and drop arrangements. The service is suitable for airport transfers, local travel, business trips, family journeys, sightseeing, and outstation transportation."
},
{
"name": "Innova on Rent for Outstation",
"description": "Book Innova on Rent for Outstation travel when you need spacious and comfortable transportation for longer routes. The service is suitable for family vacations, group trips, corporate journeys, religious tours, and intercity travel."
},
{
"name": "Innova Crysta Outstation Charges",
"description": "Check Innova Crysta Outstation Charges based on the selected route, journey type, travel schedule, and vehicle requirements. The premium vehicle is suitable for families, executives, corporate passengers, tourists, and groups."
},
{
"name": "Innova Outstation Rentals",
"description": "Choose Innova Outstation Rentals for comfortable chauffeur-driven transportation across long-distance routes. The service provides a practical option for families, groups, corporate travelers, sightseeing trips, religious journeys, and personal travel."
},
{
"name": "Innova Crysta Cab Booking",
"description": "Book Innova Crysta Cab Booking for premium private transportation with spacious interiors and professional chauffeur assistance. It is suitable for airport transfers, corporate travel, family trips, special occasions, sightseeing, and outstation journeys."
},
{
"name": "8 Seater Innova on Rent in Pune",
"description": "Choose 8 Seater Innova on Rent in Pune for spacious group transportation with practical seating and luggage capacity. The vehicle is suitable for family trips, group travel, airport transfers, sightseeing, corporate journeys, and outstation routes."
},
{
"name": "Innova Booking for Marriage in Pune",
"description": "Book Innova for Marriage in Pune for comfortable guest transportation during wedding functions and related events. Spacious vehicles can be arranged for family members, guests, wedding groups, venue transfers, airport pickups, and local transportation."
},
{
"name": "Innova Cab for Rent in Pune",
"description": "Choose Innova Cab for Rent in Pune for spacious private transportation with professional chauffeur service. The vehicle can be arranged for local travel, airport transfers, family functions, business requirements, sightseeing, and outstation journeys."
},
{
"name": "Innova Cab for Outstation",
"description": "Book Innova Cab for Outstation travel for comfortable long-distance transportation with ample passenger and luggage space. It is suitable for families, groups, corporate travelers, tourists, pilgrimage trips, and intercity journeys."
},
{
"name": "Innova Cab Service in Pune",
"description": "Choose Innova Cab Service in Pune for reliable chauffeur-driven transportation across local and outstation routes. The spacious vehicle is suitable for families, groups, airport transfers, business travel, sightseeing, and long-distance journeys."
},
{
"name": "Innova Car Taxi in PCMC",
"description": "Book Innova Car Taxi in PCMC for comfortable transportation across Pimpri-Chinchwad and surrounding areas. The service is suitable for local trips, airport transfers, corporate travel, family journeys, sightseeing, and outstation transportation."
},
{
"name": "Innova Crysta Booking in Pune",
"description": "Make Innova Crysta Booking in Pune for premium and spacious private transportation. The vehicle is suitable for executives, families, corporate passengers, airport transfers, weddings, sightseeing, and long-distance outstation journeys."
},
{
"name": "Innova Crysta Cab",
"description": "Choose Innova Crysta Cab for comfortable premium transportation with spacious seating, luggage capacity, and professional chauffeur assistance. It is suitable for family travel, corporate requirements, airport transfers, special occasions, and outstation trips."
},
{
"name": "Innova Crysta for Taxi",
"description": "Book Innova Crysta for Taxi requirements when you need a spacious and premium vehicle for private travel. It is suitable for airport transfers, corporate journeys, family trips, weddings, sightseeing, and long-distance transportation."
},
{
"name": "Innova Crysta Taxi Booking",
"description": "Make Innova Crysta Taxi Booking for scheduled premium transportation with convenient pickup arrangements. The vehicle is suitable for families, executives, corporate travelers, tourists, airport passengers, and groups requiring comfortable private travel."
},
{
"name": "Innova Crysta Taxi Price",
"description": "Check Innova Crysta Taxi Price according to the journey type, travel route, pickup location, and vehicle requirements. The spacious premium vehicle can be arranged for local travel, airport transfers, corporate journeys, and outstation trips."
},
{
"name": "Innova Crysta Taxi Price Per Km",
"description": "Check Innova Crysta Taxi Price Per Km according to the selected travel plan and journey requirements. The premium vehicle provides spacious seating and comfortable interiors for families, executives, groups, and long-distance passengers."
},
{
"name": "Innova for Rent Outstation",
"description": "Choose Innova for Rent Outstation journeys for comfortable transportation with professional chauffeur assistance. The vehicle is suitable for family vacations, group trips, business travel, sightseeing, religious tours, and long-distance road journeys."
},
{
"name": "Innova for Outstation Trip",
"description": "Book Innova for Outstation Trip travel when you need additional passenger and luggage space for a long journey. The service is suitable for families, friends, corporate groups, tourists, and passengers planning one-way or round-trip travel."
},
{
"name": "Innova for Taxi",
"description": "Choose Innova for Taxi transportation when spacious seating and comfortable private travel are important. The vehicle can be arranged for local trips, airport transfers, family travel, business journeys, sightseeing, and outstation requirements."
},
{
"name": "Innova Rent Per Kilometer",
"description": "Check Innova Rent Per Kilometer according to the selected route, travel plan, and vehicle requirements. The spacious vehicle is suitable for long-distance transportation, family trips, group travel, corporate journeys, and sightseeing."
},
{
"name": "Innova Taxi for Outstation",
"description": "Book Innova Taxi for Outstation travel for spacious and comfortable transportation between cities. Professional chauffeurs and suitable travel arrangements make it practical for families, groups, corporate travelers, tourists, and pilgrimage journeys."
},
{
"name": "Innova Taxi Rates for Outstation",
"description": "Check Innova Taxi Rates for Outstation travel according to the route, journey type, vehicle requirements, and travel schedule. Customers can arrange comfortable one-way or round-trip transportation for family, business, and leisure journeys."
},
{
"name": "Online Innova Taxi Booking",
"description": "Book Online Innova Taxi Booking for convenient advance travel planning without visiting a booking office. Customers can arrange suitable pickup times, destinations, vehicle requirements, and chauffeur-driven transportation for local or outstation travel."
}
],
"tableData": [
["Innova Taxi", "Book Innova for Outstation"],
["Innova Taxi Near Me Pune", "Innova Cab Booking"],
["Innova Booking Near Me Pimpri", "Innova Car Rental for Outstation"],
["Innova for Airport Drop", "Book Innova Crysta for Outstation"],
["Innova Crysta Taxi", "Innova Cab Rental"],
["Innova Outstation Charges", "Pune Innova for Outstation"],
["Innova Taxi Booking", "Innova on Rent for Outstation"],
["Innova Crysta Outstation Charges", "Innova Outstation Rentals"],
["Innova Crysta Cab Booking", "8 Seater Innova on Rent in Pune"],
["Innova Booking for Marriage in Pune", "Innova Cab for Rent in Pune"],
["Innova Cab for Outstation", "Innova Cab Service in Pune"],
["Innova Car Taxi in PCMC", "Innova Crysta Booking in Pune"],
["Innova Crysta Cab", "Innova Crysta for Taxi"],
["Innova Crysta Taxi Booking", "Innova Crysta Taxi Price"],
["Innova Crysta Taxi Price Per Km", "Innova for Rent Outstation"],
["Innova for Outstation Trip", "Innova for Taxi"],
["Innova Rent Per Kilometer", "Innova Taxi for Outstation"],
["Innova Taxi Rates for Outstation", "Online Innova Taxi Booking"]
]
,



whychoose: [
  {
    WhyChooseheading: "Pune Innova Cabs for Comfortable Local & Outstation Travel",
    WhyChoosedescription: "An Innova cab is a practical choice for families, corporate travellers, tourists, and groups looking for comfortable transportation in Pune, airport transfers, sightseeing, and long-distance outstation journeys."
  },
  {
    WhyChooseheading: "Spacious Travel for Families & Groups",
    WhyChoosedescription: "The Innova provides a useful combination of passenger comfort and luggage space, making it suitable for families, small groups, and travellers carrying bags during longer journeys."
  },
  {
    WhyChooseheading: "Convenient for Pune Airport Transfers",
    WhyChoosedescription: "Passengers can arrange an Innova for Pune Airport pickup or drop requirements, particularly when travelling with family members, colleagues, or multiple pieces of luggage."
  },
  {
    WhyChooseheading: "A Practical Choice for Corporate Travel",
    WhyChoosedescription: "Companies and professionals can use Innova cabs for meetings, client visits, conferences, office travel, corporate events, and transportation between different business locations in Pune."
  },
  {
    WhyChooseheading: "Suitable for Pune Sightseeing",
    WhyChoosedescription: "Tourists and local residents can use an Innova for Pune sightseeing, family outings, shopping trips, hotel transfers, and visits to attractions across the city."
  },
  {
    WhyChooseheading: "Reliable Option for Outstation Trips",
    WhyChoosedescription: "The spacious vehicle is well suited for longer road journeys from Pune to destinations such as Mumbai, Mahabaleshwar, Goa, Shirdi, Nashik, Aurangabad, and other preferred locations."
  },
  {
    WhyChooseheading: "One-Way & Round-Trip Travel",
    WhyChoosedescription: "Travellers can select a one-way cab for direct transportation to another city or choose a round-trip arrangement when the same vehicle is required for a return journey or multi-day travel plan."
  },
  {
    WhyChooseheading: "Easy Booking with Garud Cab Service",
    WhyChoosedescription: "Share your Pune pickup location, destination, travel date, passenger count, luggage details, trip type, and Innova requirement with Garud Cab Service for suitable cab booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune Innova Cabs?",
    answer: "Yes, Garud Cab Service provides Innova cab services in Pune for local travel, airport transfers, corporate transportation, sightseeing, family trips, and outstation journeys."
  },
  {
    question: "Can I book an Innova for Pune Airport?",
    answer: "Yes, an Innova can be arranged for Pune Airport pickup and drop services, especially when passengers require additional seating or luggage space."
  },
  {
    question: "Is an Innova suitable for family travel?",
    answer: "Yes, the spacious seating and luggage capacity make an Innova a practical choice for families and groups travelling within Pune or to outstation destinations."
  },
  {
    question: "Can companies book Innova cabs in Pune?",
    answer: "Yes, businesses can arrange Innova cabs for meetings, client visits, office transportation, conferences, corporate events, and other professional travel requirements."
  },
  {
    question: "Can I use a Pune Innova cab for sightseeing?",
    answer: "Yes, an Innova can be booked for Pune sightseeing, family outings, shopping trips, hotel transfers, and other local travel plans."
  },
  {
    question: "Can I book an Innova for outstation travel from Pune?",
    answer: "Yes, Innova cabs can be arranged for outstation journeys from Pune to destinations such as Mumbai, Mahabaleshwar, Goa, Shirdi, Nashik, Aurangabad, and other cities."
  },
  {
    question: "Can I book a one-way Innova cab from Pune?",
    answer: "Yes, one-way Innova cab service can be arranged when you need direct transportation from Pune to your selected destination without requiring the vehicle for the return journey."
  },
  {
    question: "Can I book a round-trip Innova from Pune?",
    answer: "Yes, round-trip arrangements can be planned for holidays, family visits, sightseeing trips, business travel, and journeys requiring transportation back to Pune."
  },
  {
    question: "Can I carry luggage in the Innova?",
    answer: "Yes, passengers can carry luggage according to the available vehicle capacity. Additional or bulky luggage requirements should be shared during booking."
  },
  {
    question: "How can I book a Pune Innova Cab?",
    answer: "Share your Pune pickup location, destination, travel date, passenger details, luggage requirements, one-way or round-trip preference, and Innova requirement with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback: "Our family booked an Innova in Pune for an outstation holiday. The spacious seating was convenient for everyone, and there was enough room for our travel luggage.",
    rating: 5
  },
  {
    id: 2,
    name: "Mr. Aditya Joshi",
    feedback: "I arranged an Innova for a corporate trip involving several client meetings. Having everyone travel together made the business schedule more convenient to manage.",
    rating: 5
  }
];







  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Innova Cabs",
  "image": "https://garudcabs.com/assets/images/pune-innova-cabs.webp",
  "description": "Book Pune Innova Cabs with Garud Cab for comfortable and dependable local, airport, and outstation travel. Get Innova and Innova Crysta taxi and cab rental services in Pune for family trips, business journeys, airport drops, sightseeing, and long-distance travel. Choose spacious and well-maintained Innova vehicles with professional drivers, flexible rental options, and convenient pickup and drop facilities.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-innova-cabs"
  }
};





  return (
    <div>


<Helmet>
  <title>Pune Innova Cabs | Innova Taxi & Outstation Rental | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune Innova Cabs with Garud Cab for local, airport, and outstation travel. Get Innova and Innova Crysta taxi and rental services for family trips, sightseeing, airport drops, and long-distance journeys."
  />

  <meta
    name="keywords"
    content="Innova Taxi, Book Innova for Outstation, Innova Taxi Near Me Pune, Innova Cab Booking, Innova Booking Near Me Pimpri, Innova Car Rental for Outstation, Innova for Airport Drop, Book Innova Crysta for Outstation, Innova Crysta Taxi, Innova Cab Rental, Innova Outstation Charges, Pune Innova Cab, Innova Taxi Pune, Innova Crysta Rental Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/104.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneinnovacabs;